import React from 'react';
import TranslatedText from 'components/i18n/TranslatedText';
import { DROPDOWN_TITLE } from 'css-classes';
import {
  Title,
} from './styles';
import {
  ButtonViewProps,
} from './interfaces';

export default function DefaultButtonView<T>({
  shouldHideTitle = true,
  shouldTranslate,
  placeholderText,
  isAdmin,
  isOpen,
  }: ButtonViewProps<T>) {
  if (shouldHideTitle && isOpen) {
    return null;
  }

  return shouldTranslate ? (
    <TranslatedText component={Title} componentProps={{ isAdmin }} stringKey={placeholderText} />
  ) : <Title isAdmin={isAdmin} className={DROPDOWN_TITLE}>{placeholderText}</Title>;
}
